import React, { useEffect, useState } from 'react'
import Button from '@material-ui/core/Button'
import ButtonGroup from '@material-ui/core/ButtonGroup'
import IconButton from '@material-ui/core/IconButton'
import BlockIcon from '@material-ui/icons/Block'
import CheckIcon from '@material-ui/icons/Check'
import { updateGDCScore } from '@auteco/services/gdcServices'
import { useStyles } from './styles'

const paramsNames = {
  MADUREZ: 'madurez',
  IMPACTO: 'impacto',
  COMPLEJIDAD: 'complejidad',
  SOLICITANTE: 'solicitante',
}

const QuestCard = ({ quest, partner, isEnabled, reloadGDCClusters }) => {
  // const [send, setSend] = useState(false)
  const [saved, setSaved] = useState(false)
  const initialParams = {
    [paramsNames.MADUREZ]: quest?.Madurez === "-1" ? null : Number(quest?.Madurez),
    [paramsNames.IMPACTO]: quest?.Impacto === "-1" ? null : Number(quest?.Impacto),
    [paramsNames.COMPLEJIDAD]: quest?.Complejidad === "-1" ? null : Number(quest?.Complejidad),
    [paramsNames.SOLICITANTE]: null,
  }
  const classes = useStyles()
  const [scores, setScores] = useState(initialParams)
  const [change, setChange] = useState(false)

  const handleUpdateQuest = async ({ score, type }) => {
    let updatedScores;
    if (scores[type] === score) {
      updatedScores = {
        ...scores,
        [type]: null,
      }
    } else {
      updatedScores = {
        ...scores,
        [type]: score,
      }
    }
    const isNull = Object.values(updatedScores).every((value) => value === null)
    if (isNull) {
      setChange(false)
      // setSend(false)
    } else {
      // setSend(false)
      setChange(true)
    }
    setScores(updatedScores)
    setSaved(false)
  }


  const handleSendQuest = async () => {
    const updatedScores = {
      ...scores,
      id: quest.id,
      solicitante: partner
    }
    const { success } = await updateGDCScore({ params: updatedScores })
    if (success) {
      // setSend(true)
      setSaved(true)
      // setTimeout(() => setSaved(false), 2000)
    }
    reloadGDCClusters()
  }

  const verifyScoresNotNull = () => scores[paramsNames.MADUREZ] !== null && scores[paramsNames.IMPACTO] !== null && scores[paramsNames.COMPLEJIDAD] !== null

  useEffect(() => {
    if (verifyScoresNotNull()) {
      setSaved(true)
    }
  }, [])
  return (
    <div className={classes.cardContainer}>
      <div className={classes.header}>
        <b>{quest.punto}</b>
      </div>
      <div className={classes.cardRow}>
        <div className={classes.titleContainer}>
          <p>Madurez</p>
          {(change && scores[paramsNames.MADUREZ] === null) && <p className={classes.redText}>*</p>}
        </div>
        <ButtonGroup
          color="primary"
          aria-label="prima"
          size="small"
          variant="text"
        >
          <Button
            variant={scores.madurez === 3 ? 'contained' : 'outlined'}
            disabled={!isEnabled}
            onClick={() =>
              handleUpdateQuest({ score: 3, type: paramsNames.MADUREZ })
            }
          >
            Alto
          </Button>
          <Button
            variant={scores.madurez === 2 ? 'contained' : 'outlined'}
            disabled={!isEnabled}
            onClick={() =>
              handleUpdateQuest({ score: 2, type: paramsNames.MADUREZ })
            }
          >
            Medio
          </Button>
          <Button
            variant={scores.madurez === 1 ? 'contained' : 'outlined'}
            disabled={!isEnabled}
            onClick={() =>
              handleUpdateQuest({ score: 1, type: paramsNames.MADUREZ })
            }
          >
            Bajo
          </Button>
          <div>
            <IconButton
              disabled={!isEnabled}
              onClick={() =>
                handleUpdateQuest({ score: 0, type: paramsNames.MADUREZ })
              }
              aria-label="delete"
            >
              <BlockIcon
                style={{ color: scores.madurez === 0 ? 'red' : 'gray' }}
              />
            </IconButton>
          </div>
        </ButtonGroup>
      </div>
      <div className={classes.cardRow}>
        <div className={classes.titleContainer}>
          <p>Impacto</p>
          {(change && scores[paramsNames.IMPACTO] === null) && <p className={classes.redText}>*</p>}
        </div>
        <ButtonGroup
          color="primary"
          aria-label="prima"
          size="small"
          variant="text"
        >
          <Button
            variant={scores.impacto === 3 ? 'contained' : 'outlined'}
            disabled={!isEnabled}
            onClick={() =>
              handleUpdateQuest({ score: 3, type: paramsNames.IMPACTO })
            }
          >
            Alto
          </Button>
          <Button
            variant={scores.impacto === 2 ? 'contained' : 'outlined'}
            disabled={!isEnabled}
            onClick={() =>
              handleUpdateQuest({ score: 2, type: paramsNames.IMPACTO })
            }
          >
            Medio
          </Button>
          <Button
            variant={scores.impacto === 1 ? 'contained' : 'outlined'}
            disabled={!isEnabled}
            onClick={() =>
              handleUpdateQuest({ score: 1, type: paramsNames.IMPACTO })
            }
          >
            Bajo
          </Button>
          <div>
            <IconButton
              disabled={!isEnabled}
              onClick={() =>
                handleUpdateQuest({ score: 0, type: paramsNames.IMPACTO })
              }
              aria-label="delete"
            >
              <BlockIcon
                style={{ color: scores.impacto === 0 ? 'red' : 'gray' }}
              />
            </IconButton>
          </div>
        </ButtonGroup>
      </div>
      <div className={classes.cardRow}>
        <div className={classes.titleContainer}>
          <p>Complejidad </p>
          {(change && scores[paramsNames.COMPLEJIDAD] === null) && <p className={classes.redText}>*</p>}
        </div>
        <ButtonGroup
          color="primary"
          aria-label="prima"
          size="small"
          variant="text"
        >
          <Button
            variant={scores.complejidad === 3 ? 'contained' : 'outlined'}
            disabled={!isEnabled}
            onClick={() =>
              handleUpdateQuest({ score: 3, type: paramsNames.COMPLEJIDAD })
            }
          >
            Alto
          </Button>
          <Button
            variant={scores.complejidad === 2 ? 'contained' : 'outlined'}
            disabled={!isEnabled}
            onClick={() =>
              handleUpdateQuest({ score: 2, type: paramsNames.COMPLEJIDAD })
            }
          >
            Medio
          </Button>
          <Button
            variant={scores.complejidad === 1 ? 'contained' : 'outlined'}
            disabled={!isEnabled}
            onClick={() =>
              handleUpdateQuest({ score: 1, type: paramsNames.COMPLEJIDAD })
            }
          >
            Bajo
          </Button>
          <div>
            <IconButton
              disabled={!isEnabled}
              onClick={() =>
                handleUpdateQuest({ score: 0, type: paramsNames.COMPLEJIDAD })
              }
              aria-label="delete"
            >
              <BlockIcon
                style={{ color: scores.complejidad === 0 ? 'red' : 'gray' }}
              />
            </IconButton>
          </div>
        </ButtonGroup>
      </div>
      <div className={classes.statusContainer}>
        <IconButton
          className={saved ? classes.sendedButton : classes.sendButton}
          disabled={!verifyScoresNotNull() || !isEnabled}
          onClick={handleSendQuest}
        >
          <CheckIcon />
        </IconButton>
        <p className={classes.statusContainerTxt}>
          {!saved && verifyScoresNotNull() ? 'Pendiente' : saved && 'Guardado'}
        </p>
      </div>
    </div >
  )
}

export { QuestCard }
